"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthService = void 0;
var services_1 = require("@pbl/pbl-react-core/lib/services");
var axios_1 = __importDefault(require("axios"));
var jwt_decode_1 = __importDefault(require("jwt-decode"));
var constants_1 = __importDefault(require("../config/constants"));
var GET_SESSION_API = "/auth/check/session";
var AuthService = (function () {
    function AuthService() {
    }
    AuthService.login = function (body) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, services_1.AuthService.login(body, {
                                clientId: constants_1.default.CLIENT_ID,
                                clientSecret: constants_1.default.CLIENT_SECRET
                            })];
                    case 1: return [2, _b.sent()];
                    case 2:
                        e_1 = _b.sent();
                        throw e_1;
                    case 3: return [2];
                }
            });
        });
    };
    AuthService.loginWithTokenWithProvider = function (body, provider) {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, services_1.AuthService.loginWithTokenWithProvider(body, provider)];
                    case 1: return [2, _b.sent()];
                    case 2:
                        e_2 = _b.sent();
                        throw e_2;
                    case 3: return [2];
                }
            });
        });
    };
    AuthService.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, services_1.AuthService.logout()];
                    case 1:
                        _b.sent();
                        return [3, 3];
                    case 2:
                        e_3 = _b.sent();
                        throw e_3;
                    case 3: return [2];
                }
            });
        });
    };
    AuthService.unSuspend = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, services_1.AccountService.sendAccountReactivationInstructions(email)];
                    case 1:
                        _b.sent();
                        return [3, 3];
                    case 2:
                        e_4 = _b.sent();
                        throw e_4;
                    case 3: return [2];
                }
            });
        });
    };
    AuthService.isAccountActive = function (email) {
        return __awaiter(this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4, services_1.AccountService.isAccountActive(email)];
                    case 1:
                        _b.sent();
                        return [3, 3];
                    case 2:
                        e_5 = _b.sent();
                        throw e_5;
                    case 3: return [2];
                }
            });
        });
    };
    AuthService.decodeToken = function (token) {
        return (0, jwt_decode_1.default)(token);
    };
    AuthService.isAuthenticated = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        response = false;
                        return [4, services_1.AuthService.checkSession().then(function (res) {
                                response = res;
                            })];
                    case 1:
                        _b.sent();
                        return [2, response];
                }
            });
        });
    };
    AuthService.getPermissions = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2, services_1.AuthService.getPermissions()];
            });
        });
    };
    var _a;
    _a = AuthService;
    AuthService.updateLocalStorage = function (accessToken, refreshToken, userId, email) {
        window.localStorage.setItem('gameon.accessToken', accessToken);
        if (refreshToken) {
            window.localStorage.setItem('gameon.refreshToken', refreshToken);
        }
        else {
            window.localStorage.removeItem('gameon.refreshToken');
        }
        window.localStorage.setItem('gameon.userId', userId);
        window.localStorage.setItem('gameon.email', email);
    };
    AuthService.removeLocalStorage = function () {
        window.localStorage.removeItem('gameon.accessToken');
        window.localStorage.removeItem('gameon.refreshToken');
        window.localStorage.removeItem('gameon.email');
    };
    AuthService.fetchFromLocalStorage = function () {
        var accessToken = window.localStorage.getItem('gameon.accessToken');
        var refreshToken = window.localStorage.getItem('gameon.refreshToken');
        var userId = window.localStorage.getItem('gameon.userId');
        var email = window.localStorage.getItem('gameon.email');
        if (!!accessToken && !!refreshToken && !!userId) {
            return { accessToken: accessToken, refreshToken: refreshToken, userId: userId, email: email };
        }
        return {};
    };
    AuthService.checkSession = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_6;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4, axios_1.default.get(GET_SESSION_API, {
                            baseURL: constants_1.default.AUTH_URL,
                            withCredentials: true,
                            validateStatus: function (status) {
                                return status >= 200 && status <= 403;
                            }
                        })];
                case 1:
                    response = _b.sent();
                    return [2, response];
                case 2:
                    e_6 = _b.sent();
                    return [3, 3];
                case 3: return [2, null];
            }
        });
    }); };
    return AuthService;
}());
exports.AuthService = AuthService;
//# sourceMappingURL=auth-service.js.map